module.exports = __webpack_public_path__ + "img/offline_icon.14087b04.png";